import { Component, computed, input } from '@angular/core';
import { DocumentItemTypeEnum } from '@domain';
import { TranslatePipe } from '@ngx-translate/core';
import { DocumentSessionPartial } from 'src/app/domain/entities/partials/documents/document-session.partial';
import { RaViewerTextComponent } from 'src/app/shared/components/ra-viewer-text/ra-viewer-text.component';

@Component({
    selector: 'summary',
    templateUrl: 'summary.component.html',
    styleUrls: ['summary.component.scss', '../../document-preview.scss'],
    imports: [RaViewerTextComponent, TranslatePipe],
})
export class SummaryComponent {
    public sessions = input.required<DocumentSessionPartial[]>();

    /**
     * Apenas as seções que possuem um item TITLE, já com o título resolvido.
     * Seções sem título não entram no sumário (evita confundir o usuário com
     * fallbacks como "Seção N") e a numeração é sequencial sobre as restantes.
     */
    public titledSections = computed(() =>
        (this.sessions() ?? [])
            .map(session => ({ session, title: this.getTitle(session) }))
            .filter(entry => entry.title != null),
    );

    /**
     * Retorna o primeiro item do tipo TITLE de uma seção (o título da seção).
     * O título deixou de vir do `name` da seção e passou a ser um item TITLE.
     */
    public getTitle(session: DocumentSessionPartial) {
        return session?.items?.find(item => item?.type === DocumentItemTypeEnum.TITLE) ?? null;
    }

    /**
     * Retorna apenas os itens do tipo SUBTITLE de uma seção
     */
    public getSubtitles(session: DocumentSessionPartial) {
        return session?.items?.filter(item => item?.type === DocumentItemTypeEnum.SUBTITLE) ?? [];
    }

    /**
     * Rola até o título correspondente, como o sumário do PDF faz.
     *
     * Rolagem no clique, e NÃO um `<a href="#id">`: a aplicação usa HashLocationStrategy,
     * então a rota inteira vive no hash e um link de âncora o reescreveria, trocando o
     * documento pela rota 404. O mesmo motivo pelo qual a folha do PDF intercepta os
     * cliques do sumário dela (ver pdf-preview-composer).
     */
    public goTo(itemId?: string | null): void {
        if (!itemId) return;

        document
            .getElementById(`doc-item-${itemId}`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}
